import React from 'react';
import List, { ListItem } from './List';
import useTheme from '@material-ui/core/styles/useTheme';
interface Props {
  items: Array<{ title: string; id: string | number }>;
  currentId: number;
}

const getIcon = (id: number, currentId: number) => {
  if (id < currentId) {
    return 'checked';
  }
  if (id === currentId) {
    return 'dotted';
  }
  return undefined;
};

const getStyle = (id: number, currentId: number, checkedColor: string) => {
  const inlineStyle = {
    color: '#9B9B9B',
    fontWeight: 400,
  };

  if (id < currentId) {
    inlineStyle.color = checkedColor;
    inlineStyle.fontWeight = 700;
    return inlineStyle;
  }
  if (id === currentId) {
    inlineStyle.color = '#9B9B9B';
    inlineStyle.fontWeight = 700;
    return inlineStyle;
  }
  return inlineStyle;
};

const prepareItems = (items: Array<any>, currentId: number, checkedColor: string): Array<ListItem> =>
  items.map((item: any) => {
    const icon = getIcon(item.id, currentId);
    const iconColor = icon === 'checked' ? checkedColor : '#9B9B9B';

    return {
      id: item.id,
      title: item.title,
      styles: getStyle(item.id, currentId, checkedColor),
      icon,
      iconColor,
    };
  });

const ProgressList: React.FC<Props> = ({ items, currentId }) => {
  const theme = useTheme();
  return <List items={prepareItems(items, currentId, theme.palette.secondary.main)} />;
};

export default ProgressList;
